<template>
    <ul class="pagination">
      <!-- Button PREV -->
      <li class="prev">
        <router-link :to="{query: { ...$route.query,  page: currentPage - 1 } }">
        <button
          type="button"
          :disabled="isInFirstPage"
          aria-label="Go to previous page"
        >
          <img :src="srcSelect + '#icon-prev-' + this.theme" width="8" height="14"><span class="prev-mobile">Précédent</span>
        </button>
        </router-link>
      </li>

      <!-- Button "Page 1", "Page 2", etc... -->
      <li v-for="(pageButton, index) in pageButtons" :key="index" class="pagination-item">
        <router-link :to="{query: { ...$route.query,  page: pageButton.name } }">
          <button
            type="button"
            :disabled="pageButton.isDisabled"
            :class="{ active: isPageActive(pageButton.name) }"
            :aria-label="`Go to page number ${pageButton.name}`"

          >
            {{ pageButton.name }}
          </button>
        </router-link>
      </li>

      <!-- Button NEXT -->
      <li class="next">
        <router-link :to="{query: { ...$route.query,  page: currentPage + 1 } }"  :disabled="isInLastPage">
        <button
          type="button"
          :disabled="isInLastPage"
          aria-label="Go to next page"
        >
         <span class="next-mobile">Suivant</span><img :src="srcSelect + '#icon-next-' + this.theme" width="8" height="14">
        </button>
        </router-link>
      </li>
    </ul>
</template>

<script>

  /*
  Props:
  - maxVisibleButtons: nb of page buttons to display. Must be odd.
  - nbResults: Total nb of items
  - pageSize: nb of items per page
  - currentPage: current page

   */
  export default {
    name: "Pagination",
    props:{
      maxVisibleButtons: {
        type: Number,
        required: false,
        default: 5
      },
      nbResults: {
        type: Number,
        required: true
      },
      pageSize: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      },
      theme: {
        type: String,
      }
    },
    data: () => {
      return {
        srcSelect: ''
      }
    },
    mounted() {
      this.srcSelect = require(`@/assets/img/icons.svg`);
    },

    computed: {

      /**
       * Compute the nb of pages
       */
      nbPages() {
        return Math.ceil(this.nbResults / this.pageSize);
      },

      /**
       * Return true if the current page is the first one (indices start at 1, not 0)
       */
      isInFirstPage() {
        return this.currentPage <= 1;
      },

      /**
       * Return true if the current page is the last one.
       */
      isInLastPage() {
        return this.currentPage >= this.nbPages;
      },

      /**
       * Return an array of item, each item being a page button descriptor.
       */
      pageButtons() {
        const range = [];

        for (let i = this.firstPageButtonIndex; i <= this.lastPageButtonIndex; i+= 1 ) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          });
        }
        window.scroll(0,0);
        return range;
      },

      /**
       * Return the index of the first button to display.
       * Ex: [Prev] [5] [6] [7] [Next]
       * -> the first index is 5
       */
      firstPageButtonIndex() {
        var firstIndex = this.currentPage - Math.floor((this.maxVisibleButtons - 1) / 2); // floor: in case maxVisibleButton is even
        return Math.max(1, firstIndex);
      },

      /**
       * Return the index of the last button to display.
       * Ex: [Prev] [5] [6] [7] [Next]
       * -> the last index is 7
       */
      lastPageButtonIndex() {
        var lastIndex = this.firstPageButtonIndex + this.maxVisibleButtons - 1;
        return Math.min(this.nbPages, lastIndex);
      },


    },
    methods: {
      /**
       * @returns true if the given page is the current one
       */
      isPageActive(page) {
        return this.currentPage === page;
      },
    },
  }
</script>

<style lang="scss">
  .pagination {
    list-style-type: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;

    .prev, .next {
      button {
        display: flex;
        align-items: center;
        border: none;
        background: transparent;
        outline: none;
        font-size: rem(14px);
        cursor: pointer;

        &:disabled {
          opacity: 0;
        }
      }

      @include mq($until: MD) {
        .prev-mobile, .next-mobile {
          display: none;
        }
      }
    }

    .prev button {
      margin-right: rem(15px);

      img {
        margin-right: rem(10px);
      }
    }

    .next button {
      margin-left: rem(15px);

      img {
        margin-left: rem(10px);
      }
    }

    .pagination-item {
      button {
        background-color: white;
        color: color(grey-dark);
        padding: rem(10px) rem(16px);
        border: 1px solid color(border);
        outline: none;
        cursor: pointer;

        &.active {
          background-color: color(blue);
          color: white;
        }
      }
    }

    &.orange {
      .prev, .next {
        button {
          color: color(orange);
        }
      }
      .pagination-item {
        button.active {
          background-color: color(orange);
        }
      }
    }

    &.blue {
      .prev, .next {
        button {
          color: color(blue);
        }
      }
      .pagination-item {
        button.active {
          background-color: color(blue);
        }
      }
    }
  }
</style>